import { Multicall } from '../web3/multicall/multicall';

export class CustomMulticall extends Multicall {
  constructor(
    nodeUrl: string,
    multicallCustomContractAddress?: string | undefined
  ) {
    super({ multicallCustomContractAddress, tryAggregate: true, nodeUrl });
  }
}